
import AppPurchaseInfo from "@/components/purchases/PurchaseInfo.vue";
import { Purchase } from "@/models/base";
import { PurchaseService } from "@/services/purchase-service";
import Vue from "vue";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";
import { ToolbarService } from "@/services/toolbar-service";
import {TranslateResult} from "vue-i18n";

export default Vue.extend({
	data() {
		return {
			purchase: new Purchase(),
		};
	},
	computed: {
		title(): TranslateResult {
			return ToolbarService.title;
		},
		canEdit():boolean {
			return !this.purchase.ComputedFriendlyID.startsWith("-");
		}
	},
	methods: {
		goToBrowse(){
			this.$router.push("/purchase");
		},
		back() {
			this.$router.push("/purchase");
		},
		edit() {
			this.$router.push(`/purchase/edit/${this.purchase.ID}`);
		},
	},
	async created() {
		if (!checkHasModule(MODULE.AANKOOPFACTUREN, this.$router)){
			throw new Error("MISSING MODULE");
		}
		let id = parseInt(this.$route.params.id || "0");
		if (id != 0) {
			this.purchase = await PurchaseService.getPurchase(id);
		}else{
			this.$wf.notify(this.$ct("purchase-not-found"), "danger", 3000, "exclamation-triangle");
			this.$router.push("/purchase");
		}
	},
	async mounted() {
		ToolbarService.title = this.$ct("info-purchase");
	},
	components: {
		AppPurchaseInfo
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
